module.exports = __webpack_public_path__ + "img/company-logo-13.88203bdb.jpg";